import React, { useEffect, useRef, useState } from 'react';

export default function LazyImage({ src, alt = '', ...props }) {
  const [source, setSource] = useState(null);
  const imgRef = useRef(null);

  useEffect(() => {
    if ('loading' in HTMLImageElement.prototype) {
      setSource(src);
      return;
    }
    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setSource(src);
            obs.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '100px' }
    );
    if (imgRef.current) observer.observe(imgRef.current);
    return () => {
      if (imgRef.current) observer.unobserve(imgRef.current);
    };
  }, [src]);

  return <img ref={imgRef} src={source} alt={alt} loading="lazy" {...props} />;
}
